export default __webpack_public_path__ + "static/media/icon-punch.8f27823c.png";